import { useSearchParams } from 'react-router-dom';

interface Params {
  [key: string]: string;
}

const useQueryParams = (): Params => {
  const [searchParams] = useSearchParams();

  return Array.from(searchParams.entries()).reduce<Params>((result: Params, [key, value]: [string, string]) => {
    result[key] = value;

    return result;
  }, {});
};

export { useQueryParams };
